export default __webpack_public_path__ + "static/media/simple-choice.d554e112.svg";